import React from 'react'
import { useState, createState, self } from "@hookstate/core"
import { Link } from 'react-router-dom'
import * as H from 'history';
import { UserOrganizationVisitSource } from '../backendServices/BackendServices';


interface NavigationSourceState {
    src: UserOrganizationVisitSource
    searchKrit?: string
}

export const useNavigationSource = createState({src: 'UNKNOWN'} as NavigationSourceState)[self].map(s => () => {
    const state = useState(s)
    return {
        get: () => {
            return state[self].get().src
        },
        getKrit: () => {
            return state[self].get().searchKrit
        },
        set: (src: UserOrganizationVisitSource) => {
            state[self].merge({ src: src })
        },
        setKrit: (searchKrit?: string) => {
            state[self].merge({ searchKrit: searchKrit })
        },
    }
})

interface TrackingLinkProps {
    src: UserOrganizationVisitSource
    to: H.LocationDescriptor<H.LocationState> | ((location: H.Location<H.LocationState>) => H.LocationDescriptor<H.LocationState>)
    doClick?: Function
    style?: React.CSSProperties
    children?: React.ReactNode
}

const TrackingLink: React.FC<TrackingLinkProps> = ({ src, to, doClick, style, children }) => {
    const navSrc = useNavigationSource()

    const onClick = (e: any) => {
        navSrc.set(src)
        if (doClick) {
            doClick(e)
        }
    }
    return (
        < Link onClick={onClick} to={to} style={style} children={children} />
    )
}

export default TrackingLink
